module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Tom Dong | Front-end Developer","short_name":"Tom Dong","start_url":"/","background_color":"#f9f9f9","theme_color":"#f9f9f9","display":"minimal-ui","icon":"src/images/logo.png"},
    }]
